function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useState } from 'react';
import { ListingType } from '@domain-group/fe-allhomes-library';
import { Button } from '@domain-group/fe-co-allhomes-design-system';
import { SearchQuery } from '@domain-group/fe-allhomes-search-api';
import { RefreshIcon } from '@domain-group/fe-co-icon';
import { useSendEvent } from '@domain-group/fe-co-allhomes-analytics';
import * as styles from './btr-reset-box.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var doSearch = async (buildSearchApi, listingTypeName, filters) => {
  var searchApi = buildSearchApi();
  var listingType = ListingType[listingTypeName];
  var query = new SearchQuery(listingTypeName, filters.cloneWith({
    listedPropertyTypes: filters.listedPropertyTypes.default
  }), {
    pageSize: 1
  });
  return searchApi.fetchListings(listingType, query);
};
var getTextForSize = moreResults => {
  if (moreResults > 1) {
    return "are an additional ".concat(moreResults, " properties");
  }
  if (moreResults === 1) {
    return 'is an additional property';
  }
  return 'may be additional properties';
};
export var BtrResetBox = _ref => {
  var buildSearchApi = _ref.buildSearchApi,
    listingType = _ref.listingType,
    totalHits = _ref.totalHits,
    filters = _ref.filters,
    _ref$onResetFiltersCl = _ref.onResetFiltersClick,
    onResetFiltersClick = _ref$onResetFiltersCl === void 0 ? () => {} : _ref$onResetFiltersCl;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    moreResults = _useState2[0],
    setMoreResults = _useState2[1];
  useEffect(() => {
    if (buildSearchApi) {
      doSearch(buildSearchApi, listingType, filters).then(results => {
        setMoreResults(results.totalHits - totalHits);
      });
    }
  }, [setMoreResults, buildSearchApi, filters, listingType, totalHits]);
  var _useSendEvent = useSendEvent(),
    sendEvent = _useSendEvent.sendEvent;
  var handleResetFiltersClick = () => {
    sendEvent('reset-filters-click');
    onResetFiltersClick();
  };
  return ___EmotionJSX("div", {
    css: styles.btrResetBox
  }, ___EmotionJSX("div", null, ___EmotionJSX("p", {
    css: styles.title
  }, "Looking for more results?"), ___EmotionJSX("p", {
    css: styles.description
  }, "There ", getTextForSize(moreResults), " available for rent. Expand your search filters to view more available rental properties.")), ___EmotionJSX(Button, {
    icon: ___EmotionJSX(RefreshIcon, null),
    onClick: handleResetFiltersClick
  }, "Reset filters"));
};